import { ROUTE_NAMES } from '../constants';
import { type RegistrationStepType, type UserInfo } from 'interfaces';
import { getRouteFromStepName } from 'routes/getRouteFromStepName';

interface BuildUserFromRegistrationStepOptions {
  userUUID?: string;
  registrationType?: string;
}

export const isV3OrV4RegistrationFlow = (registrationFlow?: string): boolean => {
  return registrationFlow === 'v3' || registrationFlow === 'v4';
};

export const buildUserFromRegistrationStep = (
  data: RegistrationStepType,
  options: BuildUserFromRegistrationStepOptions = {},
): UserInfo => {
  const { userUUID, registrationType } = options;

  return {
    ...(data.step_data as UserInfo),
    ...(userUUID && { user_uuid: userUUID }),
    ...(registrationType && { registration_type: registrationType }),
    registration_block_reason: data.registration_block_reason,
    duplicate: {
      blacklist_reason: data.personal_info?.blacklist_reason,
      moratorium_till: data.personal_info?.moratorium_till,
      origin_info: { last_phone_digits: data.duplicate?.origin_info.last_phone_digits ?? '' },
    },
    ...(data?.document_request?.current_step && {
      document_request: data.document_request,
      transaction_id: data.document_request?.current_step?.data?.transaction_id,
    }),
    registration_flow: data.registration_flow,
    phone_number: data.personal_info?.phone_number,
    is_payment_method_required: data.step_data?.is_payment_method_required,
  };
};

export const resolveRegistrationRoute = (data: RegistrationStepType): string => {
  if (data?.document_request?.current_step) {
    return getRouteFromStepName(ROUTE_NAMES.DocumentRequest);
  }

  if (
    data.personal_info?.moratorium_till &&
    (data.personal_info?.blacklist_reason === 'dni_duplicate' ||
      data.personal_info?.blacklist_reason === 'dni_brute_force')
  ) {
    return getRouteFromStepName(ROUTE_NAMES.BlockedUser);
  }

  if (data?.registration_block_reason === 'need_manual_verification') {
    return getRouteFromStepName(ROUTE_NAMES.Selfie);
  }

  if (isV3OrV4RegistrationFlow(data.registration_flow) && data.step_name === ROUTE_NAMES.BankInfo) {
    return getRouteFromStepName(ROUTE_NAMES.ConfirmApplication);
  }

  return getRouteFromStepName(data.step_name);
};
